import React, { Component } from 'react';
import { Col, Form, Row, Spin } from 'antd';
import moment from 'moment';
import numeral from 'numeral';

import InfoBtn from '../InfoBtn/InfoBtn';
import * as programmeController from '../../services/api/programme';
import './ProgrammeInfoBtn.scss'

const FormItem = Form.Item;

export default class ProgrammeInfoBtn extends Component {
    constructor(props) {
        super(props);

        this.state = {
            programme: {},
            isLoading: false
        }
    }

    fetchProgramme() {
        const { programmeId } = this.props;

        if (programmeId) {
            this.setState({ isLoading: true });

            programmeController.getProgramme(programmeId)
                .then((res) => res.json())
                .then((json) => this.setState({ programme: json, isLoading: false }))
        }
    }

    handleVisibleChange(visible) {
        if (visible)
            this.fetchProgramme()
    }

    renderContent() {
        const { programme, isLoading } = this.state;
        const { name, status, course_code, programme_category, programme_code, tutor, programme_date, application_due_date, leads, head_count, fee } = programme;

        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 12 },
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 12 },
            },
        };

        if (isLoading)
            return (<Spin/>)
        else
            return (
                <Form className="ProgrammeInfoForm">
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Course Code">
                            	<span>{course_code ? course_code.name : ''}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Programme Category">
                            	<span>{programme_category ? programme_category.name : ''}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Programme Code">
                            	<span>{programme_code}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Name">
                            	<span>{name}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Status">
                            	<span>{status}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Tutor">
                            	<span>{tutor}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Programme Date">
                            	<span>{programme_date ? moment(programme_date).format('YYYY-MM-DD') : '--'}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Application Due Date">
                            	<span>{application_due_date ? moment(application_due_date).format('YYYY-MM-DD') : '--'}</span>
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Available Place(s)">
                            	<span>{ leads ? leads.length : 0 } / </span>{head_count}
                            </FormItem>
                        </Col>
                    </Row>
                    <Row gutter={32}>
                        <Col span={24}>
                            <FormItem {...formItemLayout} label="Fee">
                            	<span>{numeral(fee).format('$0,0')}</span>
                            </FormItem>
                        </Col>
                    </Row>
                </Form>
            )
    }

    render() {
        return (
            <InfoBtn
				content={this.renderContent()}
				onVisibleChange={(visible) => this.handleVisibleChange(visible)}
			/>
        );
    }
}

ProgrammeInfoBtn.defaultProps = {
    programmeId: ''
};


// WEBPACK FOOTER //
// ./src/components/ProgrammeInfoBtn/ProgrammeInfoBtn.js